<template>
  <div>
    <header class="head">
      <div class="main-bar">
        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <h4 class="nav_top_align text-dark font-weight-bold">
              <router-link
                :to="{ name: 'instructor.index', params: { company: company.url } }"
                class="text-csq"
              >
                <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
              </router-link>
              &nbsp; {{ form.displayName || fullName }}
            </h4>
          </div>
        </div>
      </div>
    </header>

    <div class="outer">
      <div class="inner bg-container">
        <div class="card card-csq no-shadow rounded-0">
          <div class="card-body">
            <div class="row">
              <!-- Left: profile photo -->
              <div class="col-md-4 col-lg-3 m-t-25 text-center">
                <div
                  class="card mb-3 no-shadow"
                  style="max-width: 240px; margin: auto"
                >
                  <img :src="avatarUrl" class="card-img" alt="avatar" />
                </div>
                <input
                  ref="photoInput"
                  type="file"
                  accept="image/jpeg,image/png"
                  class="d-none"
                  :disabled="isUploadingProfileImage"
                  @change="onProfileImageSelected"
                />
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  :disabled="isUploadingProfileImage"
                  @click="$refs.photoInput.click()"
                >
                  <b-icon icon="camera" class="mr-1"></b-icon>
                  {{ isUploadingProfileImage ? "กำลังอัปโหลด..." : "เพิ่มรูปโปรไฟล์" }}
                </b-button>
              </div>

              <!-- Right: form -->
              <div class="col-md-8 col-lg-9">
                <div class="card-header bg-transparent border-bottom px-0">
                  <span class="text-csq font-weight-bold">ข้อมูลผู้สอน</span>
                </div>

                <!-- ข้อมูลผู้สอน -->
                <div class="card border-0 bg-light mb-3 no-shadow mt-3">
                  <div class="card-header pt-3 border-0 bg-transparent">
                    <h5 class="card-title">ข้อมูลผู้สอน</h5>
                  </div>
                  <div class="card-body pb-0">
                    <div class="form-row">
                      <b-form-group class="col-md-6">
                        <label>ชื่อ (ภาษาไทย) <span class="text-danger">*</span></label>
                        <b-form-input
                          v-model="form.firstName"
                          :class="{ 'is-invalid': hasError('firstName') }"
                          trim
                          @input="filterThai('firstName'); clearError('firstName')"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          กรุณากรอกชื่อเป็นภาษาไทย
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <b-form-group class="col-md-6">
                        <label>นามสกุล (ภาษาไทย) <span class="text-danger">*</span></label>
                        <b-form-input
                          v-model="form.lastName"
                          :class="{ 'is-invalid': hasError('lastName') }"
                          trim
                          @input="filterThai('lastName'); clearError('lastName')"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          กรุณากรอกนามสกุลเป็นภาษาไทย
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="form-row">
                      <b-form-group class="col-md-6">
                        <label>สถาบัน</label>
                        <b-form-select
                          v-model="form.organization"
                          :options="institutionOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                    <b-form-group label="ประวัติ" class="mb-3">
                      <b-form-textarea
                        v-model="form.about"
                        rows="5"
                        placeholder="ประวัติผู้สอน"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>
                </div>

                <!-- ข้อมูลผู้ใช้งาน -->
                <div class="card border-0 bg-light mb-3 no-shadow">
                  <div class="card-header pt-3 border-0 bg-transparent">
                    <h5 class="card-title">ข้อมูลผู้ใช้งาน</h5>
                  </div>
                  <div class="card-body pb-0">
                    <div class="form-row">
                      <b-form-group class="col-md-6">
                        <label>อีเมล <span class="text-danger">*</span></label>
                        <b-form-input
                          v-model="form.email"
                          :class="{ 'is-invalid': hasError('email') }"
                          type="email"
                          trim
                          @input="clearError('email')"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          กรุณากรอกอีเมลให้ถูกต้อง
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <b-form-group class="col-md-6">
                        <label>ชื่อผู้สอน <span class="text-danger">*</span></label>
                        <b-form-input
                          v-model="form.displayName"
                          :class="{ 'is-invalid': hasError('displayName') }"
                          trim
                          @input="clearError('displayName')"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          กรุณากรอกชื่อผู้สอน
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="form-row">
                      <b-form-group class="col-md-6">
                        <label>สถานะ</label>
                        <b-form-select
                          v-model="form.status"
                          :options="statusOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <!-- เปลี่ยนรหัสผ่าน -->
                <div class="card border-0 bg-light mb-3 no-shadow">
                  <div class="card-header pt-3 border-0 bg-transparent">
                    <h5 class="card-title">เปลี่ยนรหัสผ่าน</h5>
                  </div>
                  <div class="card-body pb-0">
                    <div class="form-row">
                      <b-form-group class="col-md-6">
                        <label>รหัส</label>
                        <b-form-input
                          v-model="newPassword"
                          type="password"
                          placeholder="รหัสผ่านอย่างน้อย 5 หลัก"
                          :state="passwordState"
                          trim
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          กรุณากรอกรหัสผ่านอย่างน้อย 5 หลัก
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <button class="btn btn-dark" type="button" @click="save">
                    บันทึก
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success modal: instructor saved -->
    <b-modal
      v-model="showSuccessModal"
      centered
      hide-header
      hide-footer
      body-class="text-center p-4"
    >
      <b-icon
        icon="check-circle"
        variant="success"
        font-scale="3.5"
        class="my-3"
      ></b-icon>
      <h4 class="font-weight-bold">บันทึกข้อมูลสำเร็จ</h4>
      <p class="text-muted mb-3">แก้ไขข้อมูลผู้สอนเรียบร้อยแล้ว</p>
      <b-button variant="primary" class="px-4" @click="showSuccessModal = false">
        ตกลง
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import api from "../../../services/api";
import uploadService from "@/services/upload-service";

export default {
  components: {},
  props: { company: { type: Object, default: null } },

  data() {
    return {
      instructorId: this.$route.params.id,
      form: {
        firstName: "",
        lastName: "",
        displayName: "",
        organization: null,
        about: "",
        email: "",
        status: 1,
      },
      newPassword: "",
      isUploadingProfileImage: false,
      errors: [],
      avatarUrl: "https://s1.coursesquare.co/data/images/display.jpg",
      showSuccessModal: false,
      institutionOptions: [{ value: null, text: "เลือกสถาบัน" }],
      statusOptions: [
        { value: 1, text: "ใช้งาน" },
        { value: 0, text: "ไม่ใช้งาน" },
      ],
    };
  },

  computed: {
    fullName() {
      return `${this.form.firstName} ${this.form.lastName}`.trim();
    },
    passwordState() {
      if (!this.newPassword) return null;
      return this.newPassword.length >= 5 ? null : false;
    },
  },

  created() {
    const c = this.company || {};
    const info = this.$store.state.Company.companyInfo || {};
    const companyName =
      c.displayName || c.name || info.displayName || info.name;
    if (companyName) {
      this.institutionOptions = [
        { value: null, text: "เลือกสถาบัน" },
        { value: companyName, text: companyName },
      ];
    }
  },

  mounted() {
    this.getInstructor();
  },

  methods: {
    async getInstructor() {
      try {
        const { data } = await api.get(`/v1/instructors/${this.instructorId}`);
        const d = data.data;
        this.form.firstName = d.firstName || "";
        this.form.lastName = d.lastName || "";
        this.form.displayName = d.displayName || "";
        this.form.organization = d.organization || this.form.organization;
        this.form.about = d.about || "";
        this.form.email = d.email || "";
        this.form.status = Number(d.status) === 0 ? 0 : 1;
        if (d.organization && !this.institutionOptions.some((o) => o.value === d.organization)) {
          this.institutionOptions.push({ value: d.organization, text: d.organization });
        }
        this.avatarUrl = this.buildAvatarUrl(d.displayPath) || this.avatarUrl;
      } catch (err) {
        this.toast("โหลดข้อมูลผู้สอนไม่สำเร็จ", "danger");
      }
    },

    buildAvatarUrl(displayPath) {
      if (!displayPath) return null;
      if (/^https?:\/\//.test(displayPath)) return displayPath;
      return `${process.env.VUE_APP_API_BASE_STORAGE_URL}/${displayPath.replace(/^\/?(storage\/)?/, "")}`;
    },

    async onProfileImageSelected(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;

      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        this.toast("โปรดเลือกไฟล์ .jpg .jpeg .png เท่านั้น", "danger");
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        this.toast("ขนาดไฟล์ต้องไม่เกิน 3MB", "danger");
        return;
      }

      this.isUploadingProfileImage = true;
      try {
        await uploadService.uploadProfileImage({
          memberId: this.instructorId,
          comId: this.company.id,
          imageFile: file,
        });
        this.avatarUrl = URL.createObjectURL(file);
        await this.getInstructor();
        if (this.avatarUrl && !this.avatarUrl.startsWith("blob:")) {
          this.avatarUrl += (this.avatarUrl.includes("?") ? "&" : "?") + "t=" + Date.now();
        }
        this.toast("อัปเดตรูปโปรไฟล์เรียบร้อยแล้ว.", "success");
      } catch (error) {
        this.toast("อัปโหลดรูปโปรไฟล์ไม่สำเร็จ.", "danger");
      } finally {
        this.isUploadingProfileImage = false;
      }
    },

    clearError(field) {
      this.errors = this.errors.filter((e) => e !== field);
    },

    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    filterThai(field) {
      this.form[field] = this.form[field].replace(/[^ก-๙\s.-]/g, '');
    },

    isThaiOnly(value) {
      return /^[ก-๙\s.-]+$/.test(value);
    },

    hasError(field) {
      return this.errors.includes(field);
    },

    async save() {
      this.errors = [];
      const form = this.form;
      if (!form.firstName || !this.isThaiOnly(form.firstName)) this.errors.push("firstName");
      if (!form.lastName || !this.isThaiOnly(form.lastName)) this.errors.push("lastName");
      if (!form.email || !this.validEmail(form.email)) this.errors.push("email");
      if (!form.displayName) this.errors.push("displayName");
      if (this.errors.length) {
        this.toast("กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง", "danger");
        return;
      }

      if (this.newPassword && this.newPassword.length < 5) {
        this.toast("รหัสผ่านต้องมีอย่างน้อย 5 หลัก", "danger");
        return;
      }

      try {
        const payload = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          displayName: this.form.displayName,
          organization: this.form.organization,
          about: this.form.about,
          status: this.form.status,
          email: this.form.email,
        };

        await api.put(`/v1/instructors/${this.instructorId}`, payload);

        if (this.newPassword) {
          await api.put(
            `/v1/members/${this.instructorId}/password/?company=${this.company.id}`,
            {
              password: this.newPassword,
              password_confirmation: this.newPassword,
            }
          );
          this.newPassword = "";
        }

        this.showSuccessModal = true;
      } catch (err) {
        const data = (err.response && err.response.data) || {};
        if (data.errors && data.errors.email) this.errors.push("email");
        // Prefer specific field errors (e.g. duplicate email) over the generic
        // "The given data was invalid." wrapper message.
        const fieldMessages = Object.keys(data.errors || {}).reduce(
          (acc, key) => acc.concat(data.errors[key]),
          []
        );
        const message = fieldMessages.length
          ? fieldMessages.join(" ")
          : data.message || "บันทึกข้อมูลไม่สำเร็จ";
        this.toast(message, "danger");
      }
    },

    toast(message, variant) {
      this.$bvToast.toast(message, {
        variant,
        autoHideDelay: 3000,
        noCloseButton: true,
        solid: true,
      });
    },
  },
};
</script>

